import { AdminEvent, EventStatus, FrontendEvent, } from 'common/types';
import { makeAutoObservable, action } from 'mobx';
import { BackendUser, BackendPartner } from 'common/types';
import { useNotification } from 'hooks/use-notification/useNotification';

class CreateEventStore {
    adminEvent: AdminEvent = {
        title: '',
        subTitle: '',
        type: '',
        description: '',
        speakers: [],
        sponsors: [],
        cost: [],
        scheduled: false,
        registrationStartDate: '',
        status: '',
        date: '',
        metaData: {
            timeZone: { description: 'Eastern Standard Time', abbr: 'EST', value: 'America/Toronto' },
            attendanceType: 'Virtual',
            eventProvider: 'None',
            country: '',
            showQRRadio: true,
        }
    };

    initialAdminEvent: AdminEvent = this.adminEvent
    
    backendUser: BackendUser | null = null;
    backendPartner: BackendPartner | null = null;
    sizeError = false;
    typeError: false;
    fileName: string = '';
    isSummit: boolean = false;
    error: boolean = false;
    showPreviewModal: boolean = false;
    scheduled: boolean = false;
    disableScheduledSwitch: boolean = false;
    bannerPreviewImage = '';
    bannerFileName = '';
    emailBannerFileName = '';
    scheduledDateError?: boolean = false;
    titleError: boolean = false;
    frontendEvent: FrontendEvent = undefined;
    hideSummit: boolean = false;
    videoPreview = '';
    confirmCancel: boolean = false;
    videoFileName = '';
    seatingCapacityError: boolean = false;
    eventDateError: boolean = false;
    eventTimeError: boolean = false;
    thumbnailFileName = '';
    thumbnailPreview = '';
    videoThumbnailFileName = '';
    videoThumbnailPreview = '';
    isLoading: boolean = false;
    timeError: boolean;
    dateError: boolean


    constructor() {
        makeAutoObservable(this);
    }

    setAdminEvent = (adminEvent: AdminEvent) => {
        this.adminEvent = adminEvent;
    };

    setError = (error: boolean) => {
        this.error = error;
    };

    setShowPreviewModal = (showPreviewModal: boolean) => {
        this.showPreviewModal = showPreviewModal;
    };

    setBannerPreviewImage = (bannerPreviewImage: string) => {
        this.bannerPreviewImage = bannerPreviewImage;
    };
    setBannerFileName = (bannerFileName: string) => {
        this.bannerFileName = bannerFileName;
    }
    setEmailBannerFileName = (emailBannerFileName: string) => {
        this.emailBannerFileName = emailBannerFileName;
    }

    setScheduled = (scheduled: boolean) => {
        this.scheduled = scheduled;
    }

    setDisableScheduledSwitch = (disableScheduledSwitch: boolean) => {
        this.disableScheduledSwitch = disableScheduledSwitch;
    }

    setScheduledDateError = (scheduledDateError?: boolean) => {
        this.scheduledDateError = scheduledDateError;
    }

    setTitleError = (titleError?: boolean) => {
        this.titleError = titleError;
    }

    setFrontendEvent = (frontendEvent: FrontendEvent) => {
        this.frontendEvent = frontendEvent;
    }

    setVideoPreview = (videoPreview: string) => {
        this.videoPreview = videoPreview;
    }

    setConfirmCancel = (confirmCancel: boolean) => {
        this.confirmCancel = confirmCancel;
    }

    setVideoFileName = (videoFileName: string) => {
        this.videoFileName = videoFileName;
    }

    setSeatingCapacityError = (seatingCapacityError: boolean) => {
        this.seatingCapacityError = seatingCapacityError;
    }

    setEventDateError = (eventDateError: boolean) => {
        this.eventDateError = eventDateError;
    }

    setEventTimeError = (eventTimeError: boolean) => {
        this.eventTimeError = eventTimeError;
    }

    setThumbnailFileName = (thumbnailFileName: string) => {
        this.thumbnailFileName = thumbnailFileName;
    }

    setThumbnailPreview = (thumbnailPreview?: string) => {
        this.thumbnailPreview = thumbnailPreview;
    }

    setVideoThumbnailFileName = (videoThumbnailFileName: string) => {
        this.videoThumbnailFileName = videoThumbnailFileName;
    }

    setVideoThumbnailPreview = (videoThumbnailPreview: string) => {
        this.videoThumbnailPreview = videoThumbnailPreview;
    }

    setIsLoading = (isLoading: boolean) => {
        this.isLoading = isLoading;
    }

    setFileName = (fileName: string) => {
        this.fileName = fileName;
    }

    setIsSummit = (isSummit: boolean) => {
        this.isSummit = isSummit
    }

    setSizeError = (sizeError: boolean) => {
        this.sizeError = sizeError;
    }

    setTypeError = (sizeError: boolean) => {
        this.sizeError = sizeError;
    }
    setTimeError = (timeError: boolean) => {
        this.timeError = timeError;
    }

    setDateError = (dateError: boolean) => {
        this.dateError = dateError;
    }

    resetAdminEventState = () => {
        this.setAdminEvent(this.initialAdminEvent)
    }
}

export const CreateEventStoreState = new CreateEventStore();
